import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';

const styles = {
  container: {
    display: 'flex',
    paddingTop: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default () => (
  <div style={styles.container}>
    <CircularProgress size={80} thickness={5} />
  </div>
);



// WEBPACK FOOTER //
// ./src/modules/components/Loader.js